import WalletAddress from "../models/WalletAddress";
export const WalletAddressMixin = {
  data() {
    return {
      wallet_address: this.initialize(),
      saving: false,
    }
  },
  methods: {
    initialize() {
      return new WalletAddress({
        rebit_account_id: this.$route.params.id,
        address: null,
        network: null,
        is_active: true,
      })
    }
  }
}
